import * as THREE from 'three';
import { DefaultColors } from '../defines';

export class HelperLine extends THREE.Line {
  constructor() {
    super();
    this.material = new THREE.LineBasicMaterial({
      color: DefaultColors.TEMPORARY_OBJECTS,
      depthTest: false,
      depthWrite: false,
    });
  }

  setBetweenPoints(points: THREE.Vector3[]) {
    this.geometry.dispose();
    this.geometry = new THREE.BufferGeometry().setFromPoints(points);
  }
}
